module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('h2', [_vm._v("Result from "), _c('u', [_c('b', [_vm._v(_vm._s(_vm.orgNumberInput))])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.accountInformation.organizationInformation')))]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('form.clients.companyName.label')) + ":\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n        " + _vm._s(_vm.orgData.name) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('form.clients.clientType.label')) + ":\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n        " + _vm._s(_vm.orgData.code) + "\n      ")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [(_vm.displayPostalAddress) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": (_vm.displayBusinessAddress && _vm.displayLocationAddress) ? 8 : 12
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayPostalAddress.street_name_2) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayPostalAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-checkbox-group', {
    on: {
      "change": function($event) {
        return _vm.addressEvent1($event)
      }
    },
    model: {
      value: (_vm.addressResult1),
      callback: function($$v) {
        _vm.addressResult1 = $$v
      },
      expression: "addressResult1"
    }
  }, _vm._l((_vm.addressTypes), function(type) {
    return _c('el-checkbox', {
      key: type.id,
      staticClass: "margin-b-10 display-block",
      staticStyle: {
        "margin-left": "30px"
      },
      attrs: {
        "label": type.id
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayBusinessAddress) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": (_vm.displayPostalAddress && _vm.displayLocationAddress) ? 8 : 12
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayBusinessAddress.street_name_2) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayBusinessAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-checkbox-group', {
    on: {
      "change": function($event) {
        return _vm.addressEvent2($event)
      }
    },
    model: {
      value: (_vm.addressResult2),
      callback: function($$v) {
        _vm.addressResult2 = $$v
      },
      expression: "addressResult2"
    }
  }, _vm._l((_vm.addressTypes), function(type) {
    return _c('el-checkbox', {
      key: type.id,
      staticClass: "margin-b-10 display-block",
      staticStyle: {
        "margin-left": "30px"
      },
      attrs: {
        "label": type.id
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayLocationAddress) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": (_vm.displayBusinessAddress && _vm.displayPostalAddress) ? 8 : 12
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.streetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.street_name) + "\n              ")])]), _vm._v(" "), (_vm.displayLocationAddress.street_name_2) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.secondStreetName')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.street_name_2) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.postalCode')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.postal) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.clients.info.city')) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v(" " + _vm._s(_vm.displayLocationAddress.city) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-checkbox-group', {
    on: {
      "change": function($event) {
        return _vm.addressEvent3($event)
      }
    },
    model: {
      value: (_vm.addressResult3),
      callback: function($$v) {
        _vm.addressResult3 = $$v
      },
      expression: "addressResult3"
    }
  }, _vm._l((_vm.addressTypes), function(type) {
    return _c('el-checkbox', {
      key: type.id,
      staticClass: "margin-b-10 display-block",
      staticStyle: {
        "margin-left": "30px"
      },
      attrs: {
        "label": type.id
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t(("form.addressTypes.options." + (_vm.camelize(type.name))))))])])
  }), 1)], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex wrap justify-center buttons_under_main_body"
  }, [_c('el-button', {
    staticClass: "dark",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.cancel')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.update')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625e4f2a","hasScoped":false}!./src/app/components/clientAddressBrreg/clientAddressBrreg.html
// module id = 3039
// module chunks = 1